import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigurePartyService {
  calculateCapacityInSelectedResources(resources = [], selectedResources = []) {
    const fullDataOfSelectedResources = resources.filter(resource => selectedResources.includes(resource._id));
    return this.calculateResourcesCapacity(fullDataOfSelectedResources);
  }

  calculateResourcesCapacity(resources = []) {
    return resources.reduce((acc, resource) => {
      acc.min += resource.capacity.min || 0;
      acc.max += resource.capacity.max || 0;
      return acc;
    }, { min: 0, max: 0 });
  }

  clean(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }
}
